import { list } from "postcss";

// config.js
const config = {
    baseUrl: 'https://manuscript-manager.bigbro.co.ke',
    // baseUrl: 'http://localhost:8000',
    apiEndpoints: {
      createFarmer: '/farmers/create',
      listFarmers: '/farmers',
      createProduct: '/products/create',
      products: '/products',
      categories: '/categories',
      createCategory: '/categories/create',
      uoms: '/uoms',
      customers: '/customers',
      createCustomer: '/customers/create',
      createUom: '/uoms/create',
      createOrder: '/orders/create',
      listOrders: '/orders',
      createPayment: '/payments/create',
      listPayments: '/payments',
      payables: '/payables',
      createPayable: '/payables/create',
      receivables: '/receivables',
      createReceivable: '/receivables/create',
      deliveries: '/deliveries',
      createDelivery: '/deliveries/create',
      users: '/users',
      // /admin/orders/3
      order: '/orders/',
      
    },
  };
  
  export default config;